import React, {Component} from 'react';
import {Dropdown, Form, Button} from 'semantic-ui-react';
import toastr from 'toastr';

import usersAccessApi from '../../store/services/userAccess';
import {fetch} from '../../store/customers';

export default class CustomerAssociationPopup extends Component {
  state = {
    selectedCustomerId: null,
    loading: false,
    customers: [],
  };
  componentDidMount() {
    this._loadCustomers();
  }

  _loadCustomers = async () => {
    const customers = await fetch(0, 0);
    this.setState({customers: customers.result.data});
  };
  _associate = async () => {
    this.setState({loading: true});
    try {
      var data = await usersAccessApi.approvePending({
        userId: this.props.userId,
        customerId: this.state.selectedCustomerId,
      });
      if (data && !data.hasErrors) {
        toastr.success(
          this.state.selectedCustomerId === 0
            ? 'Search Only Access Granted'
            : 'User Associated'
        );
      }
      this.props.onUpdated();
    } catch (error) {
      toastr.error('Unable to associate user');
    } finally {
      this.setState({loading: false});
    }
  };
  render() {
    const customerOptions = this.state.customers.map(x => ({
      text: x.name,
      value: x.id,
    }));
    if (this.props.userIsDomainRestricted) {
      customerOptions.unshift({text: 'Search Only', value: 0});
    }
    return (
      <Form onSubmit={this._associate}>
        <Dropdown
          options={customerOptions}
          value={this.state.selectedCustomerId}
          onChange={(e, {value}) => this.setState({selectedCustomerId: value})}
          selection
          search
          style={{marginTop: 10}}
        />
        <Button
          primary
          fluid
          style={{marginTop: 10}}
          loading={this.state.loading}
        >
          Submit
        </Button>
      </Form>
    );
  }
}
